// 代理商加盟api接口
import vipService from "@/services/vipService";
import { objToQuery } from "@/utils/index";

/**
 * 活动分享拉新增加vip
 * @param {*} data
 */
export function getReceive(data) {
  return vipService.post("/client/invite", data);
}

/**
 * 查看人数
 * @param {*} data
 */
export function getInvite(data) {
  return vipService.get(`/client/invite${objToQuery(data)}`);
}

/**
 * 获取活动信息
 * @param {*} data
 */
export function getActivity(data) {
  return vipService.get(`/client/activity${objToQuery(data)}`);
}
